import { sanitizeItems } from '@maestro/commerce-blocks/providers/wishlist/utils'
import { createLogger } from '@maestro/core/logger'

const log = createLogger('maestro:commerce-blocks:wishlist-storage')

const WISHLIST_KEY = 'wishlist'
const WISHLIST_ID_KEY = 'wishlistId'

/**
 * Retrieves wishlist product IDs from localStorage.
 */
export function getWishlistFromStorage(): string[] {
  if (typeof window === 'undefined') {
    return []
  }

  try {
    const data = localStorage.getItem(WISHLIST_KEY)
    if (!data) {
      return []
    }
    return sanitizeItems(JSON.parse(data))
  } catch (error) {
    log.error('Error parsing wishlist products from localStorage:', error)
    return []
  }
}

/**
 * Saves wishlist product IDs to localStorage.
 */
export function saveWishlistToStorage(items: unknown): string[] {
  const sanitizedItems = sanitizeItems(items)

  if (typeof window === 'undefined') {
    return sanitizedItems
  }

  try {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(sanitizedItems))
  } catch (error) {
    log.error('Error saving wishlist to localStorage:', error)
  }

  return sanitizedItems
}

/**
 * Retrieves wishlist ID from localStorage.
 */
export function getWishlistIdFromStorage(): string | undefined {
  if (typeof window === 'undefined') {
    return undefined
  }

  try {
    const data = localStorage.getItem(WISHLIST_ID_KEY)
    return data || undefined
  } catch (error) {
    log.error('Error reading wishlist ID from localStorage:', error)
    return undefined
  }
}

/**
 * Saves wishlist ID to localStorage.
 */
export function saveWishlistIdToStorage(wishlistId: string): void {
  if (typeof window === 'undefined') {
    return
  }

  try {
    localStorage.setItem(WISHLIST_ID_KEY, wishlistId)
  } catch (error) {
    log.error('Error saving wishlist ID to localStorage:', error)
  }
}

/**
 * Clears wishlist ID from localStorage only.
 * Use when clearing product IDs separately from ID.
 */
// export function deleteWishlistIdFromStorage(): void {
export function clearWishlistIdFromStorage(): void {
  if (typeof window === 'undefined') {
    return
  }

  try {
    localStorage.removeItem(WISHLIST_ID_KEY)
  } catch (error) {
    log.error('Error clearing wishlist ID from localStorage:', error)
  }
}

/**
 * Clears all wishlist data from localStorage (both products and ID).
 * Use for logout and session changes.
 */
// export function deleteWishlistFromStorage(): void {
export function clearWishlistDataFromStorage(): void {
  if (typeof window === 'undefined') {
    return
  }

  try {
    localStorage.removeItem(WISHLIST_KEY)
    localStorage.removeItem(WISHLIST_ID_KEY)
  } catch (error) {
    log.error('Error clearing wishlist data from localStorage:', error)
  }
}
